module.exports = __webpack_public_path__ + "static/img/benzbmw_esp.0dd7d38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/benzbmw_esp.png
// module id = QDjx
// module chunks = 1